"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlDirectoryBox", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      directory: "<"
    },
    transclude: true,
    template: require("./tlDirectoryBox.html"),
    controller: function controller($scope, $translate) {
      var ctrl = this;
      $scope.renduNbDocs = function (directory) {
        if (directory.nbDocsRec === 0) {
          return $translate("documents.Aucun");
        } else if (directory.nbDocsRec === 1) {
          return "1 " + $translate("documents.document");
        } else {
          return directory.nbDocsRec + " " + $translate("documents.documents");
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/documents/tlDirectoryBox.js
// module id = 2776
// module chunks = 13